import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reportFundraiserComment } from '@client/connectivity/api.fundraiserComment';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import Flex from '@client/components/flex/Flex';

function ReportConfirmation({
  className,
  fundraiserId,
  commentId,
  toggleModal,
  setShowHasBeenReported,
  setShowReportBtn,
}) {
  let timer = undefined;
  const [reported, setReported] = useState(false);
  const toggleModalAndReportButton = () => {
    setShowHasBeenReported(true);
    setShowReportBtn(false);
  };

  function onReportComment() {
    reportFundraiserComment(fundraiserId, commentId)
      .then(() => {
        setReported(true);
        timer = setTimeout(toggleModalAndReportButton, 3000);
      })
      .catch((error) => {
        console.log('report error', error);
      });
  }

  useEffect(() => {
    return () => {
      if (timer) {
        toggleModalAndReportButton();
        clearTimeout(timer);
      }
    };
  }, []);

  return (
    <Flex alignCenter justifyCenter wrap className={className ? className : ''}>
      {reported ? (
        <h2>
          Tack, inlägget kommer att granskas av Hjärt-Lungfonden inom kort.
        </h2>
      ) : (
        <>
          <h2>Vill du rapportera detta inlägg till Hjärt-Lungfonden?</h2>
          <button
            className={`${styleHelper.btnPrimaryLg} ${styleHelper.marginRight}`}
            onClick={onReportComment}
            autoFocus={true}
          >
            Ja, rapportera.
          </button>
        </>
      )}
      <button className={styleHelper.btnSecondaryAltLg} onClick={toggleModal}>
        Gå tillbaka
      </button>
    </Flex>
  );
}

ReportConfirmation.propTypes = {
  className: PropTypes.string,
  toggleModal: PropTypes.func,
  fundraiserId: PropTypes.string,
  commentId: PropTypes.string,
  dispatch: PropTypes.func,
  setShowHasBeenReported: PropTypes.func,
  setShowReportBtn: PropTypes.func,
};

export default connect()(ReportConfirmation);
